import { render, staticRenderFns } from "./TagAssignment.vue?vue&type=template&id=c2b9e9c2"
import script from "./TagAssignment.vue?vue&type=script&lang=js"
export * from "./TagAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports